import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Contact } from '../models/database-classes';
import { ApiClientService, Kontakt } from '../services/api-client.service';
import { UserStatusService } from '../services/user-status.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private userStatusService: UserStatusService) { }

  ngOnInit() {
    // Start periodic checks if user is logged in
    if (localStorage.getItem('authToken')) {
      this.userStatusService.startPeriodicChecks();
    }
  }
}
